import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight'
import Icon from '@space-shell/common/components/icon'
import clsx from 'clsx'
import styled from 'styled-components'

const Button = styled.button<{ $isSelected: boolean }>`
  background: none;
  width: 100%;
  min-height: 4.625rem;
  border: 0.0625rem solid
    ${({ $isSelected }) => ($isSelected ? 'var(--gray-900)' : 'var(--gray-300)')} !important;

  :hover {
    background-color: var(--gray-200);
  }
`
type ViewButtonItemProps = {
  title: string
  description?: string
  isSelected?: boolean
  className?: string
  onClick?: () => void
}

const ViewButtonItem = ({
  title,
  description,
  isSelected = false,
  className,
  onClick
}: ViewButtonItemProps) => {
  const classes = clsx(
    '_d-flex _justify-content-between _align-items-center _rounded _p-4 _text-left _cursor-pointer',
    className
  )

  return (
    <Button className={classes} onClick={onClick} $isSelected={isSelected}>
      <div>
        <span className='_text-gray-900 _font-weight-bold'>{title}</span>
        {description && <p className='_text-1 _text-gray-500 _mt-1 _mb-0'>{description}</p>}
      </div>
      <Icon icon={faChevronRight} className='_ml-3 _text-gray-900' />
    </Button>
  )
}

export default ViewButtonItem
